<div class="flex-grow-1">
    <div class="row flex-grow-1">
        <div appSetHeight class="col-12 pl-0 pr-0 flex-grow-1">
          <div class="h-100 overflow-auto">
              <div class="col-12 summary pl-0">
                  <div id="report">
                      <div id="form">
                        <mat-label>Start Date</mat-label>
                        <input type="datetime-local" class="date-time" placeholder="Start date" [ngModel]="selectedStartDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="selectedStartDate=startDateChanged($event)"/>
                        <mat-label>End Date</mat-label>
                        <input type="datetime-local" class="date-time" placeholder="End date" [ngModel]="selectedEndDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="selectedEndDate=endDateChanged($event)"/>
                        <input type="checkbox" class="check-box" [value]="selectedShouldAllowNulls" [checked]="selectedShouldAllowNulls" (change)="selectedShouldAllowNulls = !selectedShouldAllowNulls" /><mat-label> Include items that don't have creation dates</mat-label>
                        <input type="checkbox" class="check-box" [value]="selectedShouldIncludeDeletions" [checked]="selectedShouldIncludeDeletions" (change)="selectedShouldIncludeDeletions = !selectedShouldIncludeDeletions" /><mat-label> Include deletions</mat-label>
                        <button (click)="refreshData()" id="refresh" class="btn btn-white btn-sm">
                            Refresh
                            <span class="svg-icon svg-icon-xs ms-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                                </svg>
                            </span>
                        </button>
                        <button (click)="exportData()" id="export" class="btn btn-white btn-sm" *ngIf="data?.billingDetailsRecords?.length">
                            Export Data
                            <span class="svg-icon svg-icon-xs ms-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
                            </span>
                        </button>
                        <div id="no-data" *ngIf="!isFirstLoad && data?.billingDetailsRecords && !data?.billingDetailsRecords?.length">
                            <span>-</span>
                        </div>
                        <table id="results" class='table table-striped' aria-labelledby="tableLabel" *ngIf="data?.billingDetailsRecords?.length">
                            <thead>
                            <tr>
                                <th class="description2">
                                    ID
                                </th>
                                <th class="description">
                                    NAME
                                </th>
                                <th class="description">
                                    DEPOT NAME
                                </th>
                                <th class="default">
                                    TYPE
                                </th>
                                <th class="count">
                                    SKIPS
                                </th>
                                <th class="count">
                                    ROROS
                                </th>
                                <th class="count">
                                    ALL VEHICLES
                                </th>
                                <th class="count">
                                    SKIP VEHICLES
                                </th>
                                <th class="count">
                                    RORO VEHICLES
                                </th>
                                <th class="count">
                                    MOBILE SCANNER
                                </th>
                                <th class="default">
                                    DATE CREATED
                                </th>
                                <th class="default">
                                    DATE DELETED
                                </th>
                                <th class="default">
                                    REASON
                                </th>
                            </tr>
                            </thead>
                            <tbody class="dummy">
                            <tr>
                                <td class="h-2" colspan="12"></td>
                            </tr>
                            </tbody>
                            <tbody>
                                <ng-container *ngFor="let record of data.billingDetailsRecords">
                                    <tr>
                                        <td class="description2" title="{{ record.id }}">
                                            {{ record.id }}
                                        </td>
                                        <td class="description" title="{{ record.customerName }}">
                                            {{ record.customerName }}
                                        </td>
                                        <td class="description" title="{{ record.depotName }}">
                                            {{ record.depotName }}
                                        </td>
                                        <td class="default" title="{{ record.type }}">
                                            {{ record.type }}
                                        </td>
                                        <td class="count">
                                            {{ record.skips }}
                                        </td>
                                        <td class="count">
                                            {{ record.roRos }}
                                        </td>
                                        <td class="count">
                                            {{ record.allVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.skipVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.roRoVehicles }}
                                        </td>
                                        <td class="count">
                                            {{ record.mobileScanner }}
                                        </td>
                                        <td class="default">
                                            {{ record.dateCreatedDisplay }}
                                        </td>
                                        <td class="default">
                                            {{ record.dateDeletedDisplay }}
                                        </td>
                                        <td class="description" title="{{ record.reason }}">
                                            {{ record.reason }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>